import type { MerchantPsp } from '@bp/admins-shared/core/models';
import { composeEntitiesListApiActions } from '@bp/admins-shared/features/entity';

export const ACTIONS_SCOPE = '[Domain][Merchant Psps]';

const scope = `[API]${ ACTIONS_SCOPE }`;

export const MERCHANT_PSPS_LIST_API_ACTIONS = composeEntitiesListApiActions<MerchantPsp>(scope);
